import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { inject } from 'vue';
  import { ColletionBinStore } from '@/stores';
  import SelfRecyclingFormSubmitted from '@/components/self-recycling-form-submitted.vue';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const collectionBinStore = inject('collectionBinStore') as ColletionBinStore;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SelfRecyclingFormSubmitted, { "collection-bin-store": _unref(collectionBinStore) }, null, 8, ["collection-bin-store"]))
}
}

})